import script from "./FerrigationView.vue?vue&type=script&setup=true&lang=js"
export * from "./FerrigationView.vue?vue&type=script&setup=true&lang=js"

import "./FerrigationView.vue?vue&type=style&index=0&id=28328dd1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28328dd1"]])

export default __exports__